import { type Component, createEffect, onCleanup } from "solid-js";

interface Props {
  title: string;
  section: string;
  excerpt: string;
  onClose: () => void;
}

/**
 * "Why this matched" popover. Closes on X, Escape, or backdrop click.
 * Renders unconditionally — caller controls mount/unmount via <Show>.
 */
export const MatchModal: Component<Props> = (props) => {
  // Close on Escape.
  createEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") props.onClose();
    };
    document.addEventListener("keydown", handler);
    onCleanup(() => document.removeEventListener("keydown", handler));
  });

  // Lock body scroll while open.
  createEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    onCleanup(() => {
      document.body.style.overflow = prev;
    });
  });

  return (
    <div
      class="modal-backdrop"
      onClick={props.onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") props.onClose();
      }}
      role="presentation"
    >
      <dialog
        class="modal"
        open
        aria-modal="true"
        aria-labelledby="match-modal-title"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <button type="button" class="modal-close" onClick={props.onClose} aria-label="Close">
          ×
        </button>
        <p class="modal-eyebrow">Matched in {props.section}</p>
        <h2 id="match-modal-title" class="modal-title">
          {props.title}
        </h2>
        <p class="modal-excerpt">{props.excerpt}</p>
      </dialog>
    </div>
  );
};
